module.exports = __webpack_public_path__ + "static/img/selection_4.1121edf1.png";